import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */
export const styles = {
  emptyWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: 1,
  },
  searchIcon: {
    color: 'gray.16',
    fontSize: 40,
  },
  iconWrapper: {
    marginBottom: 1.5,
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
  },
  loader: {
    height: 24,
    width: 24,
  },
  resultsLabel: { display: 'flex', justifyContent: 'space-between' },
}
